import { mapGetters } from 'vuex'

export const RouterPath = {
  computed: {
    ...mapGetters(['categorylist'])
  },
  methods: {
    pushurl(filter) {
      let sub_params = [];
      for (let key of this.categorylist.keys) {
          let terms = this.categorylist.data[key].terms.filter((item) => filter.indexOf(item.id) >= 0);
          let url = "";
          if (terms.length) {
              url += key + "=";
              for (const term of terms) {
                  url += term.id + ","
              }
              url = url.substring(0, url.length - 1);
              sub_params.push(url);
          }
      }

      if (sub_params.length)
        this.$router.push("/?" + sub_params.join("&"))
      else
        this.$router.push("/")
    },
  }
}